
export function formateDate (date) {
     // 计算年月日时分的函数
     var date = new Date(date)
     var Y = date.getFullYear() + '-'
     var M = (date.getMonth() + 1) <10?'0'+(date.getMonth() + 1)+ '-' :(date.getMonth() + 1) + '-' 
     var D = date.getDate()<10?'0'+date.getDate()+ ' ':date.getDate()+ ' '
     var h = date.getHours() + ':'
     var m = date.getMinutes() + ':'
     var s = date.getSeconds()
     return Y + M + D + h + m + s
  }
  export function formateDate2 (date) {
    // 计算年月日时分的函数
    var date = new Date(date)
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1) + '-'
    var D = date.getDate()
    var h = date.getHours() + ':'
    var m = date.getMinutes() + ':'
    var s = date.getSeconds()
    return Y + M + D
 }
  export function ShowDate(date){
   var num = date
   let n = num;
   let d = new Date();
   let year = d.getFullYear();
   let mon = d.getMonth() + 1;
   let day = d.getDate();
   if(day <= n) {
       if(mon > 1) {
           mon = mon - 1;
       } else {
           year = year - 1;
           mon = 12;
       }
   }
   d.setDate(d.getDate() - n);
   year = d.getFullYear();
   mon = d.getMonth() + 1;
   day = d.getDate();
   let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
   return s;
}

  
export function formateDate3 (date) {
    // 计算年月日时分的函数
    var date = new Date(date)
    var Y = date.getFullYear() + '年'
    var M = (date.getMonth() + 1) + '月'
    var D = date.getDate()
    return M + D
 }


 export function getWeek(val) {
    let firstDay = new Date(val.getFullYear(), 0, 1)
    let dayOfWeek = firstDay.getDay()
    let spendDay = 1
    if (dayOfWeek != 0) {
      spendDay = 7 - dayOfWeek + 1
    }
    firstDay = new Date(val.getFullYear(), 0, 1 + spendDay)
    let d = Math.ceil((val.valueOf() - firstDay.valueOf()) / 86400000)
    let year = val.getFullYear()
    let week = Math.ceil(d / 7) + 1
    if(year >= new Date().getFullYear()) {
      week = week
    }
    let startTime = formateDate3( val.valueOf() - 86400000) // 周开始日期
    let endTime =  formateDate3( val.valueOf() + 5*86400000) // 周结束日期
    // { year, week, startTime, endTime }
    return '（'+ year+'年 '+'第'+ week+'周 '+ startTime+'日起）'
  }

  export function format(time, format) {
    var t = new Date(time);
    var tf = function (i) { return (i < 10 ? '0' : '') + i };
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
            case 'yyyy':
                return tf(t.getFullYear());
                break;
            case 'MM':
                return tf(t.getMonth() + 1);
                break;
            case 'mm':
                return tf(t.getMinutes());
                break;
            case 'dd':
                return tf(t.getDate());
                break;
            case 'HH':
                return tf(t.getHours());
                break;
            case 'ss':
                return tf(t.getSeconds());
                break;
        }
    })
}

export function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
      const value = params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && value !== "" && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              var subPart = encodeURIComponent(params) + "=";
              result += subPart + encodeURIComponent(value[key]) + "&";
            }
          }
        } else {
          result += part + encodeURIComponent(value) + "&";
        }
      }
    }

    result='?'+result
    const url = result.slice(0, -1);
    return url
  }
  export function isImageFile(file) {
    // 检查文件的 MIME 类型
    const mimeTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml'];
    
    // 检查文件扩展名
    const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    
    // 获取文件的 MIME 类型
    const mimeType = file.type;
    
    // 获取文件的扩展名
    const fileName = file.name;
    const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    
    // 判断是否为图片
    return mimeTypes.includes(mimeType) || validExtensions.includes(fileExtension);
}
export function isPdfFile(file) {
  // 检查文件的 MIME 类型
  const mimeType = 'application/pdf';
  
  // 检查文件的扩展名
  const validExtension = '.pdf';
  
  // 获取文件的 MIME 类型
  const fileMimeType = file.type;
  
  // 获取文件的扩展名
  const fileName = file.name;
  const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
  
  // 判断是否为 PDF 文件
  return fileMimeType === mimeType || fileExtension === validExtension;
}


// WEBPACK FOOTER //
// ./src/components/work/until/MainMethods.js